import GoalsInfoPdf from './Authentication/GoalsInfoPdf';
import LegacyInfoPdf from './Authentication/LegacyInfoPdf';

const ActionPlanPDF = ({ dataForPDf, pdfFor, Content }) => {
    const softStyle = {
        backgroundColor: '#ECFFFE',
        color: '#25676D'
    };

    const textColor = {
        color: '#25676D'
    };
    const notoSans = {
        fontFamily: 'NotoSans'
    };

    const formattedDate = new Date().toLocaleDateString('en-US', { timeZone: 'UTC' });

    return (
        <div className="px-5" style={notoSans}>
            <header className="d-flex align-items-center justify-content-between p-1 px-2 border-4 border-bottom border-light">
                <div className="d-flex justify-content-center align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="250.627" height="80.627" viewBox="0 0 208.627 80.627">
                        <g id="Group_55123" data-name="Group 55123" transform="translate(-35.373 -17.373)">
                            <g id="Group_48327" data-name="Group 48327" transform="translate(73.222 12.007)">
                                <g id="Group_55122" data-name="Group 55122" transform="translate(0 3)">
                                    <text
                                        id="round"
                                        transform="translate(21.556 57.992)"
                                        fill="#056c70"
                                        font-size="17"
                                        font-family="KohinoorTelugu-Semibold, Kohinoor Telugu"
                                        font-weight="600"
                                        letter-spacing="0.123em"
                                    >
                                        <tspan x="3" y="0">
                                            ROUND
                                        </tspan>
                                    </text>
                                    <text
                                        id="Ame"
                                        transform="translate(101.784 57.793)"
                                        fill="#056c70"
                                        font-size="17"
                                        font-family="KohinoorTelugu-Semibold, Kohinoor Telugu"
                                        font-weight="600"
                                        letter-spacing="0.1em"
                                    >
                                        <tspan x="12" y="0">
                                            AME
                                        </tspan>
                                    </text>
                                    <text
                                        id="Ame-2"
                                        data-name="Ame"
                                        transform="translate(140.784 58.793)"
                                        fill="#06706c"
                                        font-size="14"
                                        font-family="KohinoorTelugu-Semibold, Kohinoor Telugu"
                                        font-weight="600"
                                        letter-spacing="0.1em"
                                    >
                                        <tspan x="16" y="-1">
                                            .
                                        </tspan>
                                    </text>
                                    <text
                                        id="G"
                                        transform="translate(7 59)"
                                        fill="#056c70"
                                        font-size="21"
                                        font-family="KohinoorTelugu-Semibold, Kohinoor Telugu"
                                        font-weight="600"
                                    >
                                        <tspan x="0" y="-1">
                                            G
                                        </tspan>
                                    </text>
                                    <text
                                        id="G-2"
                                        data-name="G"
                                        transform="translate(87.111 59)"
                                        fill="#056c70"
                                        font-size="21"
                                        font-family="KohinoorTelugu-Semibold, Kohinoor Telugu"
                                        font-weight="600"
                                    >
                                        <tspan x="11" y="-1">
                                            G
                                        </tspan>
                                    </text>
                                </g>
                                <text
                                    id="Health"
                                    transform="translate(8 76.501)"
                                    fill="#02ada9"
                                    font-size="18"
                                    font-family="Poppins-SemiBold, Poppins"
                                    font-weight="600"
                                >
                                    <tspan x="0" y="0">
                                        HEALTH
                                    </tspan>
                                </text>
                                <text
                                    id="Trademark"
                                    transform="translate(160 45)"
                                    fill="#056c70"
                                    font-size="10"
                                    font-family="Poppins-SemiBold, Poppins"
                                    font-weight="600"
                                >
                                    <tspan x="0" y="0">
                                        ™
                                    </tspan>
                                </text>
                            </g>
                            <g id="Group_48323" data-name="Group 48323" transform="translate(31.373 48.373)">
                                <path
                                    id="Path_23202"
                                    data-name="Path 23202"
                                    d="M-8464.659-7770.893v-7.855s10.738,1.8,13.234,11.3-7.263,17.141-7.263,17.141"
                                    transform="translate(8487.875 7793.102)"
                                    fill="none"
                                    stroke="#9ac55b"
                                    stroke-linecap="square"
                                    stroke-linejoin="round"
                                    stroke-width="3"
                                />
                                <path
                                    id="Path_23203"
                                    data-name="Path 23203"
                                    d="M13.769,21.86l-.125,7.172S2.907,27.192.409,17.5,7.672,0,7.672,0"
                                    transform="translate(9.365 2.806) rotate(-0.974)"
                                    fill="none"
                                    stroke="#4bb6ae"
                                    stroke-linejoin="round"
                                    stroke-width="3"
                                />
                                <g
                                    id="Ellipse_56"
                                    data-name="Ellipse 56"
                                    transform="translate(0 0)"
                                    fill="none"
                                    stroke="#2e6c71"
                                    stroke-width="3"
                                >
                                    <circle cx="22.738" cy="22.738" r="22.738" stroke="none" />
                                    <circle cx="22.738" cy="22.738" r="21.238" fill="none" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>

                <div>
                    <div>
                        <p className="mb-1">
                            Member Name:{' '}
                            <span className="font-weight-bold" style={textColor}>
                                {dataForPDf?.memberName}
                            </span>
                        </p>

                        <p className="mb-1">
                            Member ID:{' '}
                            <span className="font-weight-bold" style={textColor}>
                                {dataForPDf?.memberCode}
                            </span>
                        </p>

                        <p className="mb-1">
                            Downloaded Date:{' '}
                            <span className="font-weight-bold" style={textColor}>
                                {formattedDate}
                            </span>
                        </p>
                    </div>
                </div>
            </header>
            {Content?.header?.map((item, index) => (
                <>
                    <div className="my-3 text-left" style={item.style || {}}>
                        <p className="fs-4 p-4">{item?.content}</p>
                    </div>
                </>
            ))}
            {/* <div className="my-3 text-left" style={softStyle}>
                <p className="fs-4 p-4">
                    GroundGame.Health works with health plans and local community groups all over the country to help plan members get the
                    support they need to maintain their health and well-being.
                </p>
            </div>
            <div className="mb-3 text-left">
                <p className="fs-4 px-4">
                    Below are the needs we identified during our call. Your care plan may be updated periodically with additional resources
                    in your area. To ensure that you have the most up-to-date information, please check the link to your care plan that was
                    shared with you via text message or email.
                </p>
            </div> */}
            {/* <div className="mb-3 text-left">
                <p className="fs-4 px-4">
                    If you have any questions, or if there is anything else that we can assist with, please call us at (813) 812-4161.
                </p>
            </div> */}
            {/* {pdfFor === 'xp' &&  */}
            <GoalsInfoPdf Content={Content} dataForPDf={dataForPDf} />
            {/* } */}
            {pdfFor === 'legacy' && <LegacyInfoPdf dataForPDf={dataForPDf}></LegacyInfoPdf>}
        </div>
    );
};

export default ActionPlanPDF;
